import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { iif } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { DataService } from 'src/app/shared/services/data.service';
import { Category } from '../../map-view/map-view.component';

@Component({
  selector: 'app-topic-completed',
  templateUrl: './topic-completed.component.html',
  styleUrls: ['./topic-completed.component.scss']
})
export class TopicCompletedComponent implements OnInit{

  id:string = ''
  isCategory: boolean = false;
  categoryInfo : Category = null;
  countryInfo: Country = null;

  constructor(private router:Router,
    private activatedRoute:ActivatedRoute,
    private dataService: DataService
  ) {

   }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(
        tap(params => {
          this.id = params['id'];
          this.isCategory = params['category'] === 'true';
        }),
        switchMap(() => 
          iif(
            () => this.isCategory,
            this.dataService.getCategorylist(), // API call if isCategory is true
            this.dataService.getCountriesMap()   // Alternative API call if isCategory is false
          )
        )
      )
      .subscribe({
        next: (res) => {
          if(this.isCategory){
            this.categoryInfo = res['data']['results'].find((v)=>v.id == this.id) as Category
          }else{
            this.countryInfo = res['data']['results'].find((v)=>v.id == this.id) as Country
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  goToNextTopic(){
    this.router.navigateByUrl('/map-view')
  }

}

interface Country {
  name: string
  id: string
  info: CountryInfo
  image: any
  flag: string
  latitude: number
  longitude: number
  marker: any
}

interface CountryInfo {
  total_questions: number
  answered_questions: number
  maximum_score: number
  score: number
  score_percentage: number
  attempted_percentage: number
  badge: string
  is_completed: boolean
}
